import React from 'react';
import loadable from '@loadable/component';

import PageContent from '../../components/page-content';
import themesQuery from './themes-query.graphql';

const ThemeContent = loadable(() =>
  import(/* webpackChunkName: "campaigns" */ './components/themes')
);

const Themes = props => (
  <PageContent withAds>
    <ThemeContent {...props} />
  </PageContent>
);

Themes.graphQL = themesQuery;

Themes.loadOrder = [];

Themes.variables = () => ({});

export default Themes;
